import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

//reemplazando valores de iniciales en estado

export default function ModalMark(props) {
  const mark = props.model;

  const [dataChanging, setDataChanging] = useState(mark);

  const [marks, setMarks] = useState([]);

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  async function listMarks() {
    let response = await wsFindBy('logi/mark');
    if (response.success) {
      const data = response.data.filter(
        ({ id: id1 }) => !props.marks.some(({ id: id2 }) => id2 === id1)
      );
      setMarks(data);
    }
  }
  useEffect(() => {
    if (mark.open) {
      listMarks();
    }
  }, [mark.open]);

  return (
    <Modal
      title="Marca"
      model={mark}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity={'base/business-partner/' + props.businessPartnerId + '/mark'}
    >
      <Autocomplete
        options={marks}
        getOptionLabel={(option) => option.description}
        defaultValue={null}
        renderInput={(params) => <TextField {...params} label="Marcas" margin="normal" required/>}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('logi_mark_id', item.id);
          }
          handleChange('logi_mark_id', null);
        }}
      />
    </Modal>
  );
}
